
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 20.498A2.252 2.252 0 013 18.248v-7.5a.75.75 0 011.5 0v7.5c0 .414.336.75.75.75h3a.75.75 0 010 1.5h-3zM.75 9.998a.75.75 0 01-.484-1.323l8.781-7.43A2.255 2.255 0 0110.5.711c.53 0 1.046.19 1.454.534l7.279 6.159a.746.746 0 01.088 1.057.751.751 0 01-1.057.088L10.985 2.39a.749.749 0 00-.969-.001L1.234 9.82a.747.747 0 01-.484.178zM18.75 5.498a.75.75 0 01-.75-.75v-2.25h-2.25a.75.75 0 010-1.5h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75zM17.25 23.498c-3.722 0-6.75-3.028-6.75-6.75s3.028-6.75 6.75-6.75S24 13.026 24 16.748s-3.028 6.75-6.75 6.75zm0-12c-2.895 0-5.25 2.355-5.25 5.25s2.355 5.25 5.25 5.25 5.25-2.355 5.25-5.25-2.355-5.25-5.25-5.25z"}}),_c('path',{attrs:{"d":"M17.25 20.498a.75.75 0 01-.75-.75v-2.25h-2.25a.75.75 0 010-1.5h2.25v-2.25a.75.75 0 011.5 0v2.25h2.25a.75.75 0 010 1.5H18v2.25a.75.75 0 01-.75.75z"}})])
          )
        }
      }
    